import { createElement, ReactNode, ForwardedRef } from 'react';
import * as motion from 'motion/react-client';
import { animControllerInView } from '@/animations';
import React from 'react';
import { AnimationProps } from './Box';

export interface IStackProps extends AnimationProps, React.HTMLAttributes<HTMLElement> {
  tag?: string;
  className?: string;
  children?: ReactNode;
  ref?: ForwardedRef<HTMLElement>;
}

const Stack = ({
  tag = 'div',
  animation = animControllerInView(),
  animate = true,
  children,
  ...props
}: IStackProps) => {
  const _animate = animate && animation;
  const _motion = _animate ? animation : null;

  return createElement(
    _animate ? getMotionTag(tag) : tag,
    {
      ...props,
      ...(_animate ? _motion : {}),
    },
    children,
  );
};

const getMotionTag = (tag: string) => {
  const tags: { [key: string]: any } = {
    div: motion.div,
    section: motion.section,
    footer: motion.footer,
    header: motion.header,
    span: motion.span,
  };

  return tags[tag] || motion.div;
};

Stack.displayName = 'Stack';

export default Stack;
